var formatSerialNumber = function (serialNumber) {
    var formattedSerial = serialNumber
        .toUpperCase()
        .replace(/[^\dA-Z]/g, '')
        .replace(/(.{4})/g, '$1 ')
        .substring(0, 9)
        .trim();
    return formattedSerial;
};

export { formatSerialNumber };
